module.exports = __webpack_public_path__ + "img/bg.13120945.jpg";